export const dinningOut = 
    [
        {
            "type": "restaurant",
            "info": {
                "resId": 20203053,
                "name": "The Fancave",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/3/20203053/9ac2079c65d3892b6f3ac2f412e3d619_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/3/20203053/9ac2079c65d3892b6f3ac2f412e3d619_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": false
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "4.7",
                    "rating_text": "4.7",
                    "rating_subtitle": "Excellent",
                    "rating_color": "3F7E00",
                    "votes": "132",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "4.7",
                            "reviewCount": "132",
                            "reviewTextSmall": "132 Reviews",
                            "subtext": "132 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "4.7",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "800"
                            }
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "",
                            "reviewCount": "0",
                            "reviewTextSmall": "0 Reviews",
                            "subtext": "Does not offer Delivery",
                            "color": "",
                            "ratingV2": "-",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Reviews",
                            "bgColorV2": {
                                "type": "grey",
                                "tint": "500"
                            },
                            "newOnDelivery": false
                        }
                    }
                },
                "cft": {
                    "text": "₹1,300 for two"
                },
                "cfo": {
                    "text": "₹550 for one"
                },
                "locality": {
                    "name": "Gomti Nagar, Lucknow",
                    "address": "Khasra 635-SA, Naubasta Kala, Near Deva Road, Gomti Nagar, Lucknow",
                    "localityUrl": "lucknow/gomti-nagar-restaurants"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/cafes/",
                        "name": "Cafe"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/continental/",
                        "name": "Continental"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/fast-food/",
                        "name": "Fast Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTQzXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/health-food/",
                        "name": "Healthy Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTUwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/tex-mex/",
                        "name": "Tex-Mex"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/italian/",
                        "name": "Italian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzNcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/mexican/",
                        "name": "Mexican"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/desserts/",
                        "name": "Desserts"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹1,300 for two"
                }
            },
            "order": [],
            "gold": {
                "instant": 20,
                "welcome_offer": false,
                "gold_offer": true,
                "text": "Flat",
                "offerValue": "20% OFF",
                "isGoldIcon": true
            },
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/lucknow/the-fancave-gomti-nagar/info",
                "clickActionDeeplink": ""
            },
            "distance": "10.4 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"12ceefed-3e6e-4283-9f72-c86f399ebad2\",\"location_type\":\"delivery_cell\",\"location_id\":\"4151190155136335872\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20203053\",\"element_type\":\"listing\",\"rank\":24}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [
                {
                    "type": "booking_cta",
                    "text": "Book a Table",
                    "clickUrl": "/lucknow/the-fancave-gomti-nagar/book"
                }
            ],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 19851199,
                "name": "Black Brew House",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/9/19851199/8e3d34b52ad67c45b0ed6bb43a376bc2_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/9/19851199/8e3d34b52ad67c45b0ed6bb43a376bc2_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/9/19851199/33d86bcffc824ed629089afa69c72515_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "4.1",
                    "rating_text": "4.1",
                    "rating_subtitle": "Very Good",
                    "rating_color": "5BA829",
                    "votes": "645",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "4.1",
                            "reviewCount": "645",
                            "reviewTextSmall": "645 Reviews",
                            "subtext": "645 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "4.1",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            }
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "",
                            "reviewCount": "0",
                            "reviewTextSmall": "0 Reviews",
                            "subtext": "Does not offer Delivery",
                            "color": "",
                            "ratingV2": "-",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Reviews",
                            "bgColorV2": {
                                "type": "grey",
                                "tint": "500"
                            },
                            "newOnDelivery": false
                        }
                    }
                },
                "cft": {
                    "text": "₹1,400 for two"
                },
                "cfo": {
                    "text": "₹600 for one"
                },
                "locality": {
                    "name": "Summit Building, Gomti Nagar, Lucknow",
                    "address": "15th & 16th Floor, Summit Building, Vibhuti Khand, Gomti Nagar, Lucknow",
                    "localityUrl": "lucknow/restaurants/in/summit-building-gomti-nagar"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/north-indian/",
                        "name": "North Indian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/continental/",
                        "name": "Continental"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/italian/",
                        "name": "Italian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/asian/",
                        "name": "Asian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/fast-food/",
                        "name": "Fast Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/beverages/",
                        "name": "Beverages"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/desserts/",
                        "name": "Desserts"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹1,400 for two"
                }
            },
            "order": [],
            "gold": {
                "instant": 20,
                "welcome_offer": false,
                "gold_offer": true,
                "text": "Flat",
                "offerValue": "20% OFF",
                "isGoldIcon": true
            },
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/lucknow/black-brew-house-gomti-nagar/info",
                "clickActionDeeplink": ""
            },
            "distance": "6.1 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"12ceefed-3e6e-4283-9f72-c86f399ebad2\",\"location_type\":\"delivery_cell\",\"location_id\":\"4151190155136335872\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19851199\",\"element_type\":\"listing\",\"rank\":23}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [
                {
                    "type": "booking_cta",
                    "text": "Book a Table",
                    "clickUrl": "/lucknow/black-brew-house-gomti-nagar/book"
                }
            ],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 20203053,
                "name": "The Fancave",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/3/20203053/9ac2079c65d3892b6f3ac2f412e3d619_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/3/20203053/9ac2079c65d3892b6f3ac2f412e3d619_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": false
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "4.7",
                    "rating_text": "4.7",
                    "rating_subtitle": "Excellent",
                    "rating_color": "3F7E00",
                    "votes": "132",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "4.7",
                            "reviewCount": "132",
                            "reviewTextSmall": "132 Reviews",
                            "subtext": "132 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "4.7",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "800"
                            }
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "",
                            "reviewCount": "0",
                            "reviewTextSmall": "0 Reviews",
                            "subtext": "Does not offer Delivery",
                            "color": "",
                            "ratingV2": "-",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Reviews",
                            "bgColorV2": {
                                "type": "grey",
                                "tint": "500"
                            },
                            "newOnDelivery": false
                        }
                    }
                },
                "cft": {
                    "text": "₹1,300 for two"
                },
                "cfo": {
                    "text": "₹550 for one"
                },
                "locality": {
                    "name": "Gomti Nagar, Lucknow",
                    "address": "Khasra 635-SA, Naubasta Kala, Near Deva Road, Gomti Nagar, Lucknow",
                    "localityUrl": "lucknow/gomti-nagar-restaurants"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/cafes/",
                        "name": "Cafe"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/continental/",
                        "name": "Continental"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/fast-food/",
                        "name": "Fast Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTQzXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/health-food/",
                        "name": "Healthy Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTUwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/tex-mex/",
                        "name": "Tex-Mex"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/italian/",
                        "name": "Italian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzNcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/mexican/",
                        "name": "Mexican"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/desserts/",
                        "name": "Desserts"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹1,300 for two"
                }
            },
            "order": [],
            "gold": {
                "instant": 20,
                "welcome_offer": false,
                "gold_offer": true,
                "text": "Flat",
                "offerValue": "20% OFF",
                "isGoldIcon": true
            },
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/lucknow/the-fancave-gomti-nagar/info",
                "clickActionDeeplink": ""
            },
            "distance": "10.4 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"12ceefed-3e6e-4283-9f72-c86f399ebad2\",\"location_type\":\"delivery_cell\",\"location_id\":\"4151190155136335872\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20203053\",\"element_type\":\"listing\",\"rank\":24}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [
                {
                    "type": "booking_cta",
                    "text": "Book a Table",
                    "clickUrl": "/lucknow/the-fancave-gomti-nagar/book"
                }
            ],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 18560184,
                "name": "The Terrace",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/4/18560184/a525cb045de6a1cd7abec9c4e6fce682_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/4/18560184/a525cb045de6a1cd7abec9c4e6fce682_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/4/18560184/b4a594a1e183105de417c256d73e5987_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "4.1",
                    "rating_text": "4.1",
                    "rating_subtitle": "Very Good",
                    "rating_color": "5BA829",
                    "votes": "1,111",
                    "subtext": "REVIEW",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "4.1",
                            "reviewCount": "1,111",
                            "reviewTextSmall": "1,111 Reviews",
                            "subtext": "1,111 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "4.1",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            }
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "",
                            "reviewCount": "0",
                            "reviewTextSmall": "0 Reviews",
                            "subtext": "Does not offer Delivery",
                            "color": "",
                            "ratingV2": "-",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Reviews",
                            "bgColorV2": {
                                "type": "grey",
                                "tint": "500"
                            },
                            "newOnDelivery": false
                        }
                    }
                },
                "cft": {
                    "text": "₹1,700 for two"
                },
                "cfo": {
                    "text": "₹700 for one"
                },
                "locality": {
                    "name": "Hazratganj, Lucknow",
                    "address": "4th Floor, Hotel Charans Plaza, 11 Habibulah Estate, Hazratganj, Lucknow",
                    "localityUrl": "lucknow/hazratganj-restaurants"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/north-indian/",
                        "name": "North Indian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/pizza/",
                        "name": "Pizza"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTk4XCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/salad/",
                        "name": "Salad"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/fast-food/",
                        "name": "Fast Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/street-food/",
                        "name": "Street Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/desserts/",
                        "name": "Desserts"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/beverages/",
                        "name": "Beverages"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹1,700 for two"
                }
            },
            "order": [],
            "gold": [],
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/lucknow/the-terrace-2-hazratganj/info",
                "clickActionDeeplink": ""
            },
            "distance": "1.6 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"12ceefed-3e6e-4283-9f72-c86f399ebad2\",\"location_type\":\"delivery_cell\",\"location_id\":\"4151190155136335872\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18560184\",\"element_type\":\"listing\",\"rank\":25}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 20328254,
                "name": "Cafe Delhi Heights",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/4/20328254/104cfb463ea81fd7a9a54dc0cf448712_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/4/20328254/104cfb463ea81fd7a9a54dc0cf448712_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/4/20328254/33d86bcffc824ed629089afa69c72515_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "4.5",
                    "rating_text": "4.5",
                    "rating_subtitle": "Excellent",
                    "rating_color": "3F7E00",
                    "votes": "414",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "4.7",
                            "reviewCount": "316",
                            "reviewTextSmall": "316 Reviews",
                            "subtext": "316 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "4.7",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "800"
                            }
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "4.2",
                            "reviewCount": "98",
                            "reviewTextSmall": "98 Reviews",
                            "subtext": "98 Delivery Reviews",
                            "color": "#E23744",
                            "ratingV2": "4.2",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            },
                            "newOnDelivery": false
                        }
                    }
                },
                "cft": {
                    "text": "₹1,400 for two"
                },
                "cfo": {
                    "text": "₹600 for one"
                },
                "locality": {
                    "name": "Riverside Mall, Gomti Nagar, Lucknow",
                    "address": "3rd Floor, Riverside Mall, 3 Vipin Khand, Gomti Nagar, Lucknow",
                    "localityUrl": "lucknow/restaurants/in/riverside-mall-gomti-nagar"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/continental/",
                        "name": "Continental"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/north-indian/",
                        "name": "North Indian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/chinese/",
                        "name": "Chinese"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/street-food/",
                        "name": "Street Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/fast-food/",
                        "name": "Fast Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODNcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/sea-food/",
                        "name": "Seafood"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/desserts/",
                        "name": "Desserts"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/beverages/",
                        "name": "Beverages"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹1,400 for two"
                }
            },
            "order": [],
            "gold": {
                "instant": 15,
                "welcome_offer": false,
                "gold_offer": true,
                "text": "Flat",
                "offerValue": "15% OFF",
                "isGoldIcon": true
            },
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/lucknow/cafe-delhi-heights-gomti-nagar/info",
                "clickActionDeeplink": ""
            },
            "distance": "2.6 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"12ceefed-3e6e-4283-9f72-c86f399ebad2\",\"location_type\":\"delivery_cell\",\"location_id\":\"4151190155136335872\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20328254\",\"element_type\":\"listing\",\"rank\":26}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [
                {
                    "type": "booking_cta",
                    "text": "Book a Table",
                    "clickUrl": "/lucknow/cafe-delhi-heights-gomti-nagar/book"
                }
            ],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 19293283,
                "name": "Masquerade By Mystery Rooms",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/3/19293283/6620b65dcc1696191459c694972d5b70_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/3/19293283/6620b65dcc1696191459c694972d5b70_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/3/19293283/d08110250e2aa9c8bdd95d6bdc9132f9_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "4.0",
                    "rating_text": "4.0",
                    "rating_subtitle": "Very Good",
                    "rating_color": "5BA829",
                    "votes": "772",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "4.4",
                            "reviewCount": "436",
                            "reviewTextSmall": "436 Reviews",
                            "subtext": "436 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "4.4",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            }
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "3.6",
                            "reviewCount": "336",
                            "reviewTextSmall": "336 Reviews",
                            "subtext": "336 Delivery Reviews",
                            "color": "#E23744",
                            "ratingV2": "3.6",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "600"
                            },
                            "newOnDelivery": false
                        }
                    }
                },
                "cft": {
                    "text": "₹950 for two"
                },
                "cfo": {
                    "text": "₹400 for one"
                },
                "locality": {
                    "name": "Gomti Nagar, Lucknow",
                    "address": "A-217, 2nd Floor, Vishesh Khand 1, Gomti Nagar, Lucknow",
                    "localityUrl": "lucknow/gomti-nagar-restaurants"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/cafes/",
                        "name": "Cafe"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAxOFwiXX0iXQ%3D%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/modern-indian/",
                        "name": "Modern Indian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/chinese/",
                        "name": "Chinese"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/north-indian/",
                        "name": "North Indian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/continental/",
                        "name": "Continental"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/pizza/",
                        "name": "Pizza"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/beverages/",
                        "name": "Beverages"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/desserts/",
                        "name": "Desserts"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹950 for two"
                }
            },
            "order": [],
            "gold": {
                "instant": 25,
                "welcome_offer": false,
                "gold_offer": true,
                "text": "Flat",
                "offerValue": "25% OFF",
                "isGoldIcon": true
            },
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/lucknow/masquerade-by-mystery-rooms-gomti-nagar/info",
                "clickActionDeeplink": ""
            },
            "distance": "6.2 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"12ceefed-3e6e-4283-9f72-c86f399ebad2\",\"location_type\":\"delivery_cell\",\"location_id\":\"4151190155136335872\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19293283\",\"element_type\":\"listing\",\"rank\":27}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [
                {
                    "type": "booking_cta",
                    "text": "Book a Table",
                    "clickUrl": "/lucknow/masquerade-by-mystery-rooms-gomti-nagar/book"
                }
            ],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 19287974,
                "name": "Boombox Bar Xchange",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/4/19287974/44a10e831acd6b6796aa7631ccb7fc6b_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/4/19287974/44a10e831acd6b6796aa7631ccb7fc6b_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/4/19287974/a6863da94c9ea9cc9123a33df9fd9e92_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "4.4",
                    "rating_text": "4.4",
                    "rating_subtitle": "Very Good",
                    "rating_color": "5BA829",
                    "votes": "602",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "4.4",
                            "reviewCount": "602",
                            "reviewTextSmall": "602 Reviews",
                            "subtext": "602 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "4.4",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            }
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "",
                            "reviewCount": "0",
                            "reviewTextSmall": "0 Reviews",
                            "subtext": "Does not offer Delivery",
                            "color": "",
                            "ratingV2": "-",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Reviews",
                            "bgColorV2": {
                                "type": "grey",
                                "tint": "500"
                            },
                            "newOnDelivery": false
                        }
                    }
                },
                "cft": {
                    "text": "₹2,000 for two"
                },
                "cfo": {
                    "text": "₹800 for one"
                },
                "locality": {
                    "name": "Summit Building, Gomti Nagar, Lucknow",
                    "address": "13th Floor, Summit Building, Vibhuti Khand, Gomti Nagar, Lucknow",
                    "localityUrl": "lucknow/restaurants/in/summit-building-gomti-nagar"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/north-indian/",
                        "name": "North Indian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/chinese/",
                        "name": "Chinese"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/continental/",
                        "name": "Continental"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/asian/",
                        "name": "Asian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/biryani/",
                        "name": "Biryani"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/italian/",
                        "name": "Italian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/desserts/",
                        "name": "Desserts"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/beverages/",
                        "name": "Beverages"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹2,000 for two"
                }
            },
            "order": [],
            "gold": {
                "instant": 15,
                "welcome_offer": false,
                "gold_offer": true,
                "text": "Flat",
                "offerValue": "15% OFF",
                "isGoldIcon": true
            },
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/lucknow/boombox-bar-xchange-gomti-nagar/info",
                "clickActionDeeplink": ""
            },
            "distance": "6.1 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"12ceefed-3e6e-4283-9f72-c86f399ebad2\",\"location_type\":\"delivery_cell\",\"location_id\":\"4151190155136335872\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19287974\",\"element_type\":\"listing\",\"rank\":28}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [
                {
                    "type": "booking_cta",
                    "text": "Book a Table",
                    "clickUrl": "/lucknow/boombox-bar-xchange-gomti-nagar/book"
                }
            ],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": [
                {
                    "image": {
                        "url": "https://b.zmtcdn.com/MaxSafety/DiningBadge/a9e3f60f5ed05ff69a6bfa5eb87b442e1611745067.png",
                        "aspect_ratio": 2.66666666667
                    },
                    "text": "Follows all Max Safety measures for a safe dining experience"
                }
            ]
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 801759,
                "name": "The Square - Novotel",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/9/801759/64a0e0f7e2b7824a6cafdf06a28d1fbf_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/9/801759/64a0e0f7e2b7824a6cafdf06a28d1fbf_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/9/801759/00e9e23988c26e4281079d934eece672_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "4.0",
                    "rating_text": "4.0",
                    "rating_subtitle": "Very Good",
                    "rating_color": "5BA829",
                    "votes": "646",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "4.2",
                            "reviewCount": "239",
                            "reviewTextSmall": "239 Reviews",
                            "subtext": "239 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "4.2",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            }
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "3.7",
                            "reviewCount": "407",
                            "reviewTextSmall": "407 Reviews",
                            "subtext": "407 Delivery Reviews",
                            "color": "#E23744",
                            "ratingV2": "3.7",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "600"
                            },
                            "newOnDelivery": false
                        }
                    }
                },
                "cft": {
                    "text": "₹2,500 for two"
                },
                "cfo": {
                    "text": "₹1,000 for one"
                },
                "locality": {
                    "name": "Novotel, Gomti Nagar, Lucknow",
                    "address": "Novotel Hotel CP-74, Viraj Khand, Gomti Nagar, Lucknow",
                    "localityUrl": "lucknow/restaurants/in/novotel-gomti-nagar"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/north-indian/",
                        "name": "North Indian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/mughlai/",
                        "name": "Mughlai"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjc4XCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/oriental/",
                        "name": "Oriental"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/continental/",
                        "name": "Continental"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/fast-food/",
                        "name": "Fast Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/desserts/",
                        "name": "Desserts"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹2,500 for two"
                }
            },
            "order": [],
            "gold": {
                "instant": 25,
                "welcome_offer": false,
                "gold_offer": true,
                "text": "Flat",
                "offerValue": "25% OFF",
                "isGoldIcon": true
            },
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/lucknow/the-square-novotel-gomti-nagar/info",
                "clickActionDeeplink": ""
            },
            "distance": "7.5 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"12ceefed-3e6e-4283-9f72-c86f399ebad2\",\"location_type\":\"delivery_cell\",\"location_id\":\"4151190155136335872\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"801759\",\"element_type\":\"listing\",\"rank\":29}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [
                {
                    "type": "booking_cta",
                    "text": "Book a Table",
                    "clickUrl": "/lucknow/the-square-novotel-gomti-nagar/book"
                }
            ],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 20533236,
                "name": "Chili's",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/6/20533236/37737265a59d8f852cf5ffbd771b2633_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/6/20533236/37737265a59d8f852cf5ffbd771b2633_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/chains/6/20533236/f1f920c073b5000664b367eb077de0d0_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "4.2",
                    "rating_text": "4.2",
                    "rating_subtitle": "Very Good",
                    "rating_color": "5BA829",
                    "votes": "366",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "4.5",
                            "reviewCount": "263",
                            "reviewTextSmall": "263 Reviews",
                            "subtext": "263 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "4.5",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            }
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "3.9",
                            "reviewCount": "103",
                            "reviewTextSmall": "103 Reviews",
                            "subtext": "103 Delivery Reviews",
                            "color": "#E23744",
                            "ratingV2": "3.9",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "600"
                            },
                            "newOnDelivery": false
                        }
                    }
                },
                "cft": {
                    "text": "₹1,000 for two"
                },
                "cfo": {
                    "text": "₹400 for one"
                },
                "locality": {
                    "name": "Lulu Mall, Lucknow",
                    "address": "Unit X-003 & X-004, 2nd Floor, Sushant Golf City, Shaheed Park, Sultan Road, Lulu Mall, Sadar Bazaar, Lucknow",
                    "localityUrl": "lucknow/restaurants/in/lulu-mall"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTUwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/tex-mex/",
                        "name": "Tex-Mex"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMVwiXX0iXQ%3D%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/american/",
                        "name": "American"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzNcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/mexican/",
                        "name": "Mexican"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTkzXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/bbq/",
                        "name": "BBQ"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/continental/",
                        "name": "Continental"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/burger/",
                        "name": "Burger"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTk4XCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/salad/",
                        "name": "Salad"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/beverages/",
                        "name": "Beverages"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹1,000 for two"
                }
            },
            "order": [],
            "gold": [],
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/lucknow/chilis-sadar-bazaar/info",
                "clickActionDeeplink": ""
            },
            "distance": "9.7 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"12ceefed-3e6e-4283-9f72-c86f399ebad2\",\"location_type\":\"delivery_cell\",\"location_id\":\"4151190155136335872\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20533236\",\"element_type\":\"listing\",\"rank\":30}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 18625649,
                "name": "Fusion Flavour",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/9/18625649/a7623aa922c40154f10984000ad4d336_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/9/18625649/a7623aa922c40154f10984000ad4d336_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/9/18625649/3b4d695df398bbcb9fb06ab048bce47d_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "4.2",
                    "rating_text": "4.2",
                    "rating_subtitle": "Very Good",
                    "rating_color": "5BA829",
                    "votes": "4,614",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "4.3",
                            "reviewCount": "1,411",
                            "reviewTextSmall": "1,411 Reviews",
                            "subtext": "1,411 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "4.3",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            }
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "4.0",
                            "reviewCount": "3,203",
                            "reviewTextSmall": "3,203 Reviews",
                            "subtext": "3,203 Delivery Reviews",
                            "color": "#E23744",
                            "ratingV2": "4.0",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "600"
                            },
                            "newOnDelivery": false
                        }
                    }
                },
                "cft": {
                    "text": "₹850 for two"
                },
                "cfo": {
                    "text": "₹350 for one"
                },
                "locality": {
                    "name": "Aliganj, Lucknow",
                    "address": "Plot 10, Sector 9, Vikas Nagar, Aliganj, Lucknow",
                    "localityUrl": "lucknow/aliganj-restaurants"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/north-indian/",
                        "name": "North Indian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/biryani/",
                        "name": "Biryani"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/mughlai/",
                        "name": "Mughlai"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/chinese/",
                        "name": "Chinese"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTI4XCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/sichuan/",
                        "name": "Sichuan"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹850 for two"
                }
            },
            "order": [],
            "gold": {
                "instant": 20,
                "welcome_offer": false,
                "gold_offer": true,
                "text": "Flat",
                "offerValue": "20% OFF",
                "isGoldIcon": true
            },
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/lucknow/fusion-flavour-aliganj/info",
                "clickActionDeeplink": ""
            },
            "distance": "3.1 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"12ceefed-3e6e-4283-9f72-c86f399ebad2\",\"location_type\":\"delivery_cell\",\"location_id\":\"4151190155136335872\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18625649\",\"element_type\":\"listing\",\"rank\":31}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [
                {
                    "type": "booking_cta",
                    "text": "Book a Table",
                    "clickUrl": "/lucknow/fusion-flavour-aliganj/book"
                }
            ],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 20510779,
                "name": "Barkaas Indo-Arabic Restaurant",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/9/20510779/d16a2f88c5847687c6f0ba494c7f5d23_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/9/20510779/d16a2f88c5847687c6f0ba494c7f5d23_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/9/20510779/3b4d695df398bbcb9fb06ab048bce47d_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "3.4",
                    "rating_text": "3.4",
                    "rating_subtitle": "Average",
                    "rating_color": "CDD614",
                    "votes": "261",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "3.3",
                            "reviewCount": "76",
                            "reviewTextSmall": "76 Reviews",
                            "subtext": "76 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "3.3",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "500"
                            }
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "3.5",
                            "reviewCount": "185",
                            "reviewTextSmall": "185 Reviews",
                            "subtext": "185 Delivery Reviews",
                            "color": "#E23744",
                            "ratingV2": "3.5",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "500"
                            },
                            "newOnDelivery": false
                        }
                    }
                },
                "cft": {
                    "text": "₹1,300 for two"
                },
                "cfo": {
                    "text": "₹550 for one"
                },
                "locality": {
                    "name": "Aliganj, Lucknow",
                    "address": "Plot 24, Second Floor, Chandralok Colony, Opposite Nagar Nigam Zone 3, Aliganj, Lucknow",
                    "localityUrl": "lucknow/aliganj-restaurants"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNFwiXX0iXQ%3D%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/arabian/",
                        "name": "Arabian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/mughlai/",
                        "name": "Mughlai"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTc4XCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/kebab/",
                        "name": "Kebab"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTk2XCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/mandi/",
                        "name": "Mandi"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/fast-food/",
                        "name": "Fast Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTk4XCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/salad/",
                        "name": "Salad"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/desserts/",
                        "name": "Desserts"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/beverages/",
                        "name": "Beverages"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹1,300 for two"
                }
            },
            "order": [],
            "gold": [],
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/lucknow/barkaas-indo-arabic-restaurant-1-aliganj/info",
                "clickActionDeeplink": ""
            },
            "distance": "2.3 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"12ceefed-3e6e-4283-9f72-c86f399ebad2\",\"location_type\":\"delivery_cell\",\"location_id\":\"4151190155136335872\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20510779\",\"element_type\":\"listing\",\"rank\":32}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 20190606,
                "name": "Pizza Tavola",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/chains/6/20190606/dc78a6ad04d56a26352ef24535346ae8_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/chains/6/20190606/dc78a6ad04d56a26352ef24535346ae8_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/6/20190606/ce77ffdf4fae027f932d1a1fec781139_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "4.3",
                    "rating_text": "4.3",
                    "rating_subtitle": "Very Good",
                    "rating_color": "5BA829",
                    "votes": "840",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "4.5",
                            "reviewCount": "249",
                            "reviewTextSmall": "249 Reviews",
                            "subtext": "249 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "4.5",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            }
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "4.0",
                            "reviewCount": "591",
                            "reviewTextSmall": "591 Reviews",
                            "subtext": "591 Delivery Reviews",
                            "color": "#E23744",
                            "ratingV2": "4.0",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Reviews",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "600"
                            },
                            "newOnDelivery": false
                        }
                    }
                },
                "cft": {
                    "text": "₹850 for two"
                },
                "cfo": {
                    "text": "₹350 for one"
                },
                "locality": {
                    "name": "Indira Nagar, Lucknow",
                    "address": "B-1002, Ground Floor, Near Bhootnath Market, B-Block, Indira Nagar, Lucknow",
                    "localityUrl": "lucknow/indira-nagar-restaurants"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/pizza/",
                        "name": "Pizza"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2NFwiXX0iXQ%3D%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/pasta/",
                        "name": "Pasta"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzA0XCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/sandwich/",
                        "name": "Sandwich"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/fast-food/",
                        "name": "Fast Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTYzXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/tea/",
                        "name": "Tea"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2NlwiXX0iXQ%3D%3D",
                        "url": "https://www.zomato.com/lucknow/restaurants/shake/",
                        "name": "Shake"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/desserts/",
                        "name": "Desserts"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                        "url": "https://www.zomato.com/lucknow/restaurants/beverages/",
                        "name": "Beverages"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹850 for two"
                }
            },
            "order": [],
            "gold": {
                "instant": 20,
                "welcome_offer": false,
                "gold_offer": true,
                "text": "Flat",
                "offerValue": "20% OFF",
                "isGoldIcon": true
            },
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/lucknow/pizza-tavola-1-indira-nagar/info",
                "clickActionDeeplink": ""
            },
            "distance": "3.6 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"12ceefed-3e6e-4283-9f72-c86f399ebad2\",\"location_type\":\"delivery_cell\",\"location_id\":\"4151190155136335872\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20190606\",\"element_type\":\"listing\",\"rank\":33}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [
                {
                    "type": "booking_cta",
                    "text": "Book a Table",
                    "clickUrl": "/lucknow/pizza-tavola-1-indira-nagar/book"
                }
            ],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        
    ]
